export default __webpack_public_path__ + "static/media/floating_button.148dd53a.svg";